import { render, staticRenderFns } from "./CurrencyNew.vue?vue&type=template&id=a669518c&scoped=true&"
import script from "./CurrencyNew.vue?vue&type=script&lang=js&"
export * from "./CurrencyNew.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyNew.vue?vue&type=style&index=0&id=a669518c&lang=scss&scoped=true&"
import style1 from "./CurrencyNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a669518c",
  null
  
)

export default component.exports